import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { LocationsProvider } from '../../providers/locations/locations';
import moment from 'moment';
/**
 * Generated class for the CoReserveDesktopFilterSidebarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-reserve-desktop-filter-sidebar',
  templateUrl: 'co-reserve-desktop-filter-sidebar.html',
  inputs: ['allLocations']
})
export class CoReserveDesktopFilterSidebarComponent {
  filterKeyword: any;
  text: string;
  @Output() sendReserveSidebarFilters = new EventEmitter<any>();
  timeRangeSidebar: any = { lower: 0, upper: 24 };
  displayTime: any = { lower: moment().hour(this.timeRangeSidebar.lower).startOf('hour'), upper: moment().hour(this.timeRangeSidebar.upper).startOf('hour') };
  allLocations: any;
  includedLocations: any = {};
  displayIncludedLocations: any = [];
  allBranchesSelected: boolean = true;
  showBranchList: boolean = false;
  branchListOffset: string = "0px";
  @ViewChild('locationListReserveExpandButton') locationListReserveExpandButton;

  constructor(public locationsProvider: LocationsProvider) {
    locationsProvider.getLocations().then((res) => {
      this.allLocations = res;
      let locationArray = [];
      this.allLocations.forEach(loc => {
        this.includedLocations[loc.id] = false;
        locationArray.push(loc.id)
        this.displayIncludedLocations.push({id: loc.id, info: loc});
      });
      this.allBranchesSelected = true;
    });
  }

  onChange(event) {
    this.displayTime = { lower: moment().hour(this.timeRangeSidebar.lower).startOf('hour'), upper: moment().hour(this.timeRangeSidebar.upper).startOf('hour') }
    // console.log('the time range', this.timeRangeSidebar)
    this.sendFilters('time', this.timeRangeSidebar, true);
  };

  expandDropdown(box) {
    // let button = document.getElementById(`locationListReserveExpandButton`).offsetTop + 34;
    let button = this.locationListReserveExpandButton.nativeElement.offsetTop + 34;
    this.branchListOffset = button + 'px';
    if (this.showBranchList) {
      this.showBranchList = false;
    } else if (!this.showBranchList) {
      this.showBranchList = true;
    }
  }

  setKeyword(event) {
    if (event && event.value.length > 0) {
      this.filterKeyword = event.value.toLowerCase();
      this.sendFilters('keyword', this.filterKeyword, true);
    } else {
      this.filterKeyword = "";
      this.sendFilters('keyword', this.filterKeyword, true);
    }
  }

  chooseAllLocations(event) {
    if (event.value) {
      let locationArray = [];
      Object.keys(this.includedLocations).forEach(loc => {
        this.includedLocations[loc] = false;
        locationArray.push(loc);
      });
      this.sendFilters('location', locationArray, true);
      this.allBranchesSelected = true;
    };
  }

  checkIfAllSelected(inputArray, filterType) {
    if (inputArray.length != 0) {
      return false;
    } else {
      return true;
    };
  }

  setLocations(event) {
    let locationArray = [];
    for (let location in this.includedLocations) {
      this.includedLocations[location] === true ? locationArray.push(location) : false;
    };
    this.sendFilters('location', locationArray, true);
    this.allBranchesSelected = this.checkIfAllSelected(locationArray, 'location');
    if (event.value){
      this.allBranchesSelected = false;
    } else if (!event.value && locationArray.length === 0){
      this.chooseAllLocations('');
      this.allBranchesSelected = true;
    } else {
    };
  }

  clickForAllLocations(event){
    this.allBranchesSelected = true;
  }

  sendFilters(tab, info, active) {
    let params = { type: tab, stats: info, on: active };
    this.sendReserveSidebarFilters.emit(params);
  };

}



// WEBPACK FOOTER //
// ./src/components/co-reserve-desktop-filter-sidebar/co-reserve-desktop-filter-sidebar.ts